export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/14ed8dc335eec8ccd043173219a4387f.svg";